//@ts-check

/**
 * @module Selection
 */

/**
 * Applies scope.pickColor to group/elements the viewer
 * @param {string} group_ID 
 */
export function applySelection(group_ID) {
  let scope = this;

  let group = scope.interaction.selectAll('#' + group_ID);
  
  // Store the original state of the element for later restoration
  if (group.attr('data-filtered') === 'true') {
    group.attr('data-was-filtered', true);
    group.attr('data-filtered-opacity', group.attr('data-opacity'));
  }
  
  if (group.attr('data-ghosted') === 'true') {
    group.attr('data-was-ghosted', true);
  }
  
  group.attr('data-isSel', true);
  scope.temp_pick.push(group);
  scope.colorGroup(group, scope.pickColor);

  var label = scope.overlay.selectAll('#' + group_ID);
  if ((label._groups && label._groups.length != 0) && (label._groups[0].length > 0)) {
    label.attr('data-isSel', true);
    scope.temp_pick.push(label);
    scope.colorGroup(label, scope.pickColor);
  }
}

/**
 * Selects single element or group
 * @param {string} group_ID 
 * @returns {Object} - Return success or error messages 
 */
export function selectElement(group_ID) {
  let scope = this;
  scope.clear_pickSelection();
  if (scope.interaction._groups && scope.interaction._groups.length != 0) {
    try {
      scope.applySelection(group_ID);
      return {
        "status": "success",
        "message": "Group/Element is selected"
      }
    } catch {
      return {
        "status": "failed",
        "message": "ERROR : Invalid element id: " + group_ID
      }
    }
  } else {
    return {
      "status": "failed",
      "message": "ERROR : Drawing is not loaded in viewer.'"
    }
  }
}

/**
 * Selects multiple elements /groups
 * @param {Array<string>} group_IDs 
 * @param {boolean} clear If true then clears already selected element. If a false value is selected then the selected element remains selected.
 */
export function selectElements(group_IDs, clear) {
  let scope = this;

  if (scope.interaction._groups && scope.interaction._groups.length != 0) {
    if (clear)scope.clear_pickSelection();
    
    for (let i = 0; i < group_IDs.length; i++) {
      try {
        scope.applySelection(group_IDs[i]);
      } catch {
        return {
          "status": "failed",
          "message": "ERROR : Invalid element id: " + group_IDs[i]
        }
      }
    }
  } else {
    return {
      "status": "failed",
      "message": "ERROR : Drawing is not loaded in viewer.'"
    }
  }
}

/**
 * Get Selected element/groups names
 * @returns {Object | Array<string>} List of the elements names
 */
export function getSelected() {
  let scope = this;
  return scope.arrayElements;
}

/**
 * Clears Selection
 */
export function clear_pickSelection() {
  let scope = this;
  scope.temp_pick.forEach(group => {
    group.attr('data-isSel', false);
    
    // Check if element was filtered before selection
    if (group.attr('data-was-filtered') === 'true') {
      // Restore filtered state
      group.attr('data-filtered', true);
      let opacity = group.attr('data-filtered-opacity') || 0.3;
      group.selectAll(scope.types).style('opacity', opacity);
      // Clean up temporary attributes
      group.attr('data-was-filtered', null);
    }
    else if (group.attr('data-was-ghosted') === 'true') {
      // Restore ghosted state
      group.attr('data-ghosted', true);
      scope.colorGroup(group, scope.ghostColor);
      // Clean up temporary attributes
      group.attr('data-was-ghosted', null);
    }
    else {
      // Standard non-filtered element
      scope.colorGroup(group, scope.hoverColor);
    }
  });

  scope.temp_pick = [];
  scope.arrayElements = [];
}

/**
 * Enable or disable the multiple selection 
 * @param {boolean} status If true value then enable the multiple selection If passed false value then disable the multiple selection and set to the single element selection
 * @returns {Object} Return success or error messages 
 * { status:  mesage: }
 */
export function multiSelection(status) {
  let scope = this;
  try {
    if (status != undefined || status != null) {
      scope.multipleSelectionFlagCheck = status;
      return {
        'status': 'success',
        'message': 'Multiple selection enabled successfully.'
      }
    }
    else {
      return {
        'status': 'failed',
        'message': 'ERROR : Status value is either undefined or null.'
      }
    }
  }
  catch (err) {
    return {
      'status': 'failed',
      'message': "System Error: " + err.message
    }
  }
}

